export function buildProjectAutomationPayload(draft) {
  if (!draft.sourceRunGuid) throw new Error('请选择已成功交付的手动成果')
  if (!String(draft.name || '').trim() || String(draft.cron || '').trim().split(/\s+/).length !== 5) throw new Error('请填写名称和有效的五段定时规则')
  return { projectGuid: draft.projectGuid, sourceRunGuid: draft.sourceRunGuid, name: String(draft.name).trim(),
    cron: String(draft.cron).trim(), timezone: draft.timezone || 'Asia/Shanghai' }
}
